/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：682__part-0
 */

"use strict"

var r = {
  "zh-CN": {
    widget: "控件",
    widgetName: "画布",
    backgroundColor: "背景颜色"
  }
}
export { r }
